import React, { useEffect, useCallback, useState } from "react";
import { Table, Spinner, Button, Form } from "react-bootstrap";
// Layout İmportu
import Layout from "../../layout/Layout";
import { getTodayFormsAdmin } from "../../../api/uretim/operatorScreen";
import { useNavigate } from "react-router-dom";

function OperatorScreen() {
  const navigate = useNavigate();

  // === STATE ===
  const [selectedDate] = useState(
    //const [selectedDate, setSelectedDate] = useState(

    new Date().toISOString().split("T")[0]
  );
  const [selectedMakina, setSelectedMakina] = useState(1);
  const [loading, setLoading] = useState(false);
  const [operatorList, setOperatorList] = useState([]);
  const [zaman, setZaman] = useState({ saat: "", tarih: "" });

  // === SAAT ===
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setZaman({
        saat: now.toLocaleTimeString("tr-TR"),
        tarih: now.toLocaleDateString("tr-TR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          weekday: "long",
        }),
      });
    };
    updateTime();
    const t = setInterval(updateTime, 1000);
    return () => clearInterval(t);
  }, []);

  const loadData = useCallback(
    async (makinaNo, dateParam) => {
      try {
        if (operatorList.length === 0) setLoading(true);

        const currentMakina = makinaNo || selectedMakina;
        const currentDate = dateParam || selectedDate;

        const res = await getTodayFormsAdmin(currentMakina, currentDate);

        if (res.data && res.data.rows) {
          setOperatorList(res.data.rows);
        } else {
          setOperatorList([]);
        }
      } catch (err) {
        console.error("Veri çekme hatası:", err);
        setOperatorList([]);
      } finally {
        setLoading(false);
      }
    },
    [operatorList.length, selectedMakina, selectedDate]
  );

  useEffect(() => {
    loadData(selectedMakina, selectedDate);

    const interval = setInterval(
      () => loadData(selectedMakina, selectedDate),
      30000
    );
    return () => clearInterval(interval);
  }, [loadData, selectedMakina, selectedDate]);

  // === YARDIMCI FONKSİYONLAR ===
  const isEmpty = (v) => v === null || v === undefined || v === "" || v === "-";

  const shouldBlink = (value, row) => {
    if (!row.isCompleted) return false;
    return isEmpty(value);
  };

  const getDurusToplam = (duruslar, fiiliCalismaSuresi = 0) => {
    if (!duruslar) return Number(fiiliCalismaSuresi || 0);
    const durusToplam = Object.entries(duruslar)
      .filter(([key]) => !key.toLowerCase().includes("note"))
      .reduce((t, [, v]) => t + Number(v || 0), 0);
    return durusToplam + Number(fiiliCalismaSuresi || 0);
  };

  const formatDateTime = (epoch) => {
    if (!epoch) return "-";
    return new Date(epoch).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getVardiyaTipi = (row) => {
    if (!row.epochTarih) return "-";
    const d = new Date(row.epochTarih);
    const totalMinute = d.getHours() * 60 + d.getMinutes();

    // 08:30 - 18:00 Arası GÜNDÜZ
    if (totalMinute >= 510 && totalMinute < 1080) return "GUNDUZ";

    // Diğer saatler GECE
    return "GECE";
  };

  return (
    <Layout>
      <style>{`
        /* Yanıp Sönme Efekti */
        .blink-cell {
          animation: blinkCell 0.9s infinite;
          background-color: #fff3cd; 
        }
        @keyframes blinkCell {
          0%   { background-color: #fff3cd; }
          50%  { background-color: #ffcc80; } 
          100% { background-color: #fff3cd; }
        }
        
        /* Tablo Genel Ayarları */
        .custom-table th, .custom-table td {
            vertical-align: middle;
            text-align: center;
            font-size: 0.85rem;
            padding: 5px;
            white-space: nowrap;
        }
        .custom-table thead th {
            background-color: #f1f3f5;
            font-weight: 700;
            border-bottom: 2px solid #dee2e6;
        }

        /* === VARDİYA RENK ŞERİTLERİ (En Soldaki Çizgi) === */
        .vardiya-gunduz td:first-child {
            border-left: 8px solid #28a745 !important; 
        }
        .vardiya-gece td:first-child {
            border-left: 8px solid #003366 !important;
        }
      `}</style>

      <div style={{ padding: 15 }}>
        {/* === HEADER === */}
        <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-3">
          {/* SAAT */}
          <div className="d-flex flex-column">
            <h2 className="fw-bold m-0 text-primary">{zaman.saat}</h2>
            <span className="fw-bold fs-5 text-muted">{zaman.tarih}</span>
          </div>

          {/* MAKİNA SEÇİMİ */}
          <div className="d-flex flex-column align-items-center">
            <h4 className="fw-bold m-0 mb-2">Operatör Ekranı</h4>
            <Form.Select
              value={selectedMakina}
              onChange={(e) => setSelectedMakina(Number(e.target.value))}
              className="fw-bold text-center shadow-sm"
              style={{
                fontSize: "1.2rem",
                border: "2px solid #0d6efd",
                width: "250px",
                cursor: "pointer",
              }}
            >
              <option value={1}>MAKİNA - 1</option>
              <option value={2}>MAKİNA - 2</option>
              <option value={3}>MAKİNA - 3</option>
              <option value={4}>MAKİNA - 4</option>
            </Form.Select>
          </div>

          {/* SAĞ TARAF (Tarih inputunu kaldırdın ama layout bozulmasın diye boş div bıraktım) */}
          <div
            className="d-flex flex-column align-items-end"
            style={{ gap: 5 }}
          >
            {/* Buraya tekrar tarih seçici koymak istersen ekleyebilirsin, şu an boş. */}
          </div>
        </div>

        {/* === TABLO === */}
        {loading && operatorList.length === 0 ? (
          <div className="text-center mt-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="table-responsive shadow-sm rounded bg-white">
            <Table bordered hover responsive className="custom-table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tarih / Saat</th>
                  <th>Form No</th>
                  <th>İş Emri</th>
                  <th>Firma</th>
                  <th>Malzeme</th>
                  <th>Kalınlık</th>
                  <th>En 1</th>
                  <th>En 2</th>
                  <th>Boy</th>
                  <th>Bağ</th>
                  <th>Y. Bağ</th>
                  <th>Mamül(Kg)</th>
                  <th>Süre(Dk)</th>
                  <th>Operatör</th>
                  <th>Durum</th>
                  <th>İşlem</th>
                </tr>
              </thead>

              <tbody>
                {operatorList.map((row, idx) => {
                  const isReadonly = row.readonly;
                  const durusToplam = getDurusToplam(
                    row.duruslar,
                    row.fiiliCalismaSuresi
                  );
                  const vardiya = getVardiyaTipi(row);

                  // Vardiyaya göre class belirle
                  let rowClass = "";
                  if (vardiya === "GUNDUZ") rowClass = "vardiya-gunduz";
                  else if (vardiya === "GECE") rowClass = "vardiya-gece";

                  return (
                    <tr
                      key={row._id || idx}
                      className={rowClass}
                      style={{
                        backgroundColor: isReadonly ? "#fcfcfc" : "inherit",
                        color: isReadonly ? "#555" : "inherit",
                      }}
                    >
                      <td>{idx + 1}</td>
                      <td style={{ fontWeight: "500" }}>
                        {formatDateTime(row.epochTarih)}
                      </td>

                      <td
                        className={
                          shouldBlink(row.formNo, row) ? "blink-cell" : ""
                        }
                      >
                        {row.formNo || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.isEmriNo, row) ? "blink-cell" : ""
                        }
                      >
                        {row.isEmriNo || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.firma, row) ? "blink-cell" : ""
                        }
                      >
                        {row.firma || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.malzemeCinsi, row) ? "blink-cell" : ""
                        }
                      >
                        {row.malzemeCinsi || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.kalinlik, row) ? "blink-cell" : ""
                        }
                      >
                        {row.kalinlik || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.en1, row) ? "blink-cell" : ""
                        }
                      >
                        {row.en1 || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.en2, row) ? "blink-cell" : ""
                        }
                      >
                        {row.en2 || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.boy, row) ? "blink-cell" : ""
                        }
                      >
                        {row.boy || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.bagAdeti, row) ? "blink-cell" : ""
                        }
                      >
                        {row.bagAdeti || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.yarimBag, row) ? "blink-cell" : ""
                        }
                      >
                        {row.yarimBag || "-"}
                      </td>
                      <td
                        className={
                          shouldBlink(row.mamulMiktariKg, row)
                            ? "blink-cell"
                            : ""
                        }
                      >
                        {row.mamulMiktariKg || "-"}
                      </td>
                      <td>{durusToplam}</td>
                      <td className="fw-bold text-secondary">
                        {row.operator || "-"}
                      </td>
                      <td>
                        {row.isCompleted ? (
                          <span
                            className="badge bg-success"
                            style={{ fontSize: "0.75em" }}
                          >
                            Tamam
                          </span>
                        ) : (
                          <span
                            className="badge bg-warning text-dark"
                            style={{ fontSize: "0.75em" }}
                          >
                            Devam
                          </span>
                        )}
                      </td>
                      <td>
                        <Button
                          variant={
                            isReadonly ? "outline-secondary" : "outline-primary"
                          }
                          size="sm"
                          className="fw-bold"
                          style={{ fontSize: "0.75rem", padding: "2px 6px" }}
                          onClick={() =>
                            navigate(`/boruProfilDetay/${row._id}`, {
                              state: { readonly: isReadonly },
                            })
                          }
                        >
                          Detay
                        </Button>
                      </td>
                    </tr>
                  );
                })}
                {operatorList.length === 0 && (
                  <tr>
                    <td colSpan="17" className="text-center p-4 text-muted">
                      Kayıt Yok
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default OperatorScreen;
